export function isRunningInConnectDesktop(env = process.env): boolean {
    return env._GD_STARTING_CONTEXT_ !== undefined;
}

export function parseStartingContext(env = process.env): { gatewayApp?: boolean } | undefined {
    if (!isRunningInConnectDesktop(env)) {
        throw new Error("Not running in io.Connect Desktop");
    }
    return JSON.parse(env._GD_STARTING_CONTEXT_).applicationConfig?.customProperties;
}

